/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('La aplicación se ha iniciado mediante cache Service Worker')
    },
    registered() {
      console.log('Se ha registrado el Service Worker de manera correcta')
    },
    cached() {
      console.log('Se ha recibido información de la PWA vía cache.')
    },
    updatefound() {
      console.log('Descargando nuevo contenido...')
    },
    updated() {
      //window.location.reload(true);
      console.log('New content is available; please refresh.')
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
